import { GridOptions } from '../types/options';


/**
 * Default options.
 *
 * @since 0.3.0
 */
export const DEFAULTS: GridOptions = {
  rows      : 1,
  cols      : 1,
  dimensions: [],
  gap       : {},
};
